module.exports = __webpack_public_path__ + "static/media/fotolia.ddbb54a9.jpg";